import { MinWidth } from "@/ui/media";
import { Dialog, DialogStore } from "@ariakit/react";
import { AuthCardV2, ExternalLink, MiddotSeparated, useMediaQuery } from "@indietabletop/appkit";
import { useCallback } from "react";
import { Link } from "../link";
import { hrefs } from "../root-layout/fmt";
import { interactiveTextWhite } from "../utils.css";
import { RulesetVersionIndicator } from "../version-indicator";
import * as css from "./style.css";

function Footer() {
  return (
    <footer className={css.footer}>
      <div className={css.footerInfo}>
        <RulesetVersionIndicator />

        <MiddotSeparated>
          <Link className={interactiveTextWhite} href="/settings">
            Settings
          </Link>

          <Link className={interactiveTextWhite} href="/changelog">
            Changelog
          </Link>

          <Link className={interactiveTextWhite} href="/help">
            Help
          </Link>

          <ExternalLink className={interactiveTextWhite} href="https://discord.gg/g9Cugahmgq">
            Discord
          </ExternalLink>
        </MiddotSeparated>
      </div>

      <AuthCardV2 description="Enable backup & sync, quick start rules, and more!" />

      <Link href={hrefs.buy()} className={css.cta}>
        Get the Rules
      </Link>
    </footer>
  );
}

export function Sidebar(props: { store: DialogStore }) {
  const isMatch = useMediaQuery(MinWidth.MEDIUM);

  const closeSidebar = useCallback(() => props.store.hide(), [props.store]);

  return (
    <Dialog {...props} className={css.sidebar} modal={!isMatch}>
      <nav className={css.links}>
        <Link onClick={closeSidebar} href="~/" className={css.logoArea}>
          <img src="/logos/logo-small.png" alt="Home" className={css.logo} />
        </Link>

        <Link onClick={closeSidebar} href="~/army" className={css.link}>
          <h2 className={css.heading}>Army Builder</h2>
          <p className={css.sidebarDescription}>Build, print, and share your armies.</p>
        </Link>

        <Link onClick={closeSidebar} href="~/battle" className={css.link}>
          <h2 className={css.heading}>Chaos of War</h2>
          <p className={css.sidebarDescription}>Generate a battle with one click.</p>
        </Link>

        <Link onClick={closeSidebar} href="~/rules" className={css.link}>
          <h2 className={css.heading}>Core Rules</h2>
          <p className={css.sidebarDescription}>Purchase or download Hobgoblin core rules.</p>
        </Link>

        <Link onClick={closeSidebar} href="~/rules/quick-start" className={css.link}>
          <h2 className={css.heading}>Quick Start Rules</h2>
          <p className={css.sidebarDescription}>Learn the basics right inside the app.</p>
        </Link>

        <Link onClick={closeSidebar} href="~/fortune" className={css.link}>
          <h2 className={css.heading}>Fortune Cards</h2>
          <p className={css.sidebarDescription}>Use playing cards as your Fortune deck.</p>
        </Link>
      </nav>

      <Footer />
    </Dialog>
  );
}
